var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupertagFamily = function SvgSupertagFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 84,
    fill: "none",
    viewBox: "0 0 100 84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M19.618 29.94h24.376c7.07 0 13.686-3.196 17.589-8.541H2c3.93 5.345 10.52 8.54 17.59 8.54zM68.37 73.036H36.104M18.175 73.036H7.401v-21.52l7.183-21.52h50.194l14.337 21.52 17.93 7.154v14.366H86.297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M77.334 82a8.964 8.964 0 1 0 0-17.928 8.964 8.964 0 0 0 0 17.928M27.14 82a8.964 8.964 0 1 0 0-17.929 8.964 8.964 0 0 0 0 17.929M79.116 51.516H10.993M50.837 29.94h21.52V12.01h-21.52v9.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M50.922 14.952V2h-21.52v17.193"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M22.954 19.193a6.448 6.448 0 1 0 0-12.895 6.448 6.448 0 0 0 0 12.895"
  })));
};
export default SvgSupertagFamily;